package com.tregz.robbins

import androidx.compose.foundation.*
import androidx.compose.foundation.gestures.snapping.rememberSnapFlingBehavior
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.clipToBounds
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.draw.paint
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.*
import androidx.compose.ui.graphics.drawscope.scale
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.platform.LocalInspectionMode
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.coroutines.launch
import org.jetbrains.compose.resources.imageResource
import org.jetbrains.compose.resources.painterResource
import tregz.robbins.generated.resources.*

@Composable
fun Terrence(onBack: () -> Unit) {
    val deepRed = Color(0xFF660000)
    val rose = Color(0xFF996666)
    val ashRose = Color(0xFFAA9999)
    val scope = rememberCoroutineScope()
    val uriHandler = LocalUriHandler.current

    // Slideshow state moved to top for stability
    val slides = remember {
        listOf(
            Res.drawable.tr012004,
            Res.drawable.fishing1,
            Res.drawable.fishing2,
            Res.drawable.flowerz1,
            Res.drawable.flowerz2,
            Res.drawable.flybird1,
            Res.drawable.oldship1,
            Res.drawable.rivieres
        )
    }
    val listState = rememberLazyListState()
    val snapBehavior = rememberSnapFlingBehavior(lazyListState = listState)

    // Fallback for MissingResourceException in Android Studio Preview
    val isPreview = LocalInspectionMode.current
    val image = if (isPreview) null else imageResource(Res.drawable.bacwhite)
    val brush = remember(image) {
        if (image != null) {
            ShaderBrush(ImageShader(image, TileMode.Repeated, TileMode.Repeated))
        } else {
            SolidColor(Color.White)
        }
    }

    Box(
        modifier = Modifier.fillMaxSize().drawBehind {
            scale(2f, pivot = Offset.Zero) {
                drawRect(brush, size = size / 2f)
            }
        },
        contentAlignment = Alignment.Center
    ) {
        Column(
            modifier = Modifier.wrapContentWidth().verticalScroll(rememberScrollState()),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {

            Row(modifier = Modifier
                .widthIn(max = 480.dp)) {
                Box(modifier = Modifier.weight(1f).height(100.dp), contentAlignment = Alignment.BottomStart) {
                    Button(
                        onClick = onBack,
                        modifier = Modifier.padding(start = 16.dp),
                        colors = ButtonDefaults.buttonColors(containerColor = deepRed)
                    ) {
                        Text("Back", color = Color.White)
                    }
                }

                Box(modifier = Modifier.width(220.dp)
                    .clip(RoundedCornerShape(50.dp))
                    .height(100.dp)
                    .background(deepRed), contentAlignment = Alignment.Center) {

                    Box(modifier = Modifier.width(200.dp)
                        .clip(RoundedCornerShape(50.dp))
                        .height(100.dp)
                        .background(ashRose), contentAlignment = Alignment.Center) {
                        Text(
                            text = "Canadian Leathercarving Art Studio",
                            modifier = Modifier.padding(4.dp),
                            color = deepRed,
                            fontSize = 24.sp,
                            fontWeight = FontWeight.Bold,
                            fontStyle = FontStyle.Italic,
                            textAlign = TextAlign.Center
                        )
                    }
                }
                Box(modifier = Modifier.weight(1f).height(100.dp))
            }

            Spacer(modifier = Modifier.height(16.dp))

            Column(
                modifier = Modifier
                    .widthIn(max = 480.dp)
                    .clip(RoundedCornerShape(8.dp))
                    .background(ashRose)
                    .padding(horizontal = 5.dp),
                horizontalAlignment = Alignment.CenterHorizontally,
            ) {
                Text(
                    text = "Terrence Y Robbins, leathercarver",
                    modifier = Modifier.padding(4.dp),
                    color = deepRed,
                    fontSize = 24.sp,
                    fontWeight = FontWeight.Bold,
                    fontStyle = FontStyle.Italic,
                    textAlign = TextAlign.Center
                )

                // Header Section
                Column(
                    modifier = Modifier.fillMaxWidth()
                        .clip(RoundedCornerShape(6.dp))
                        .background(rose)
                        .padding(horizontal = 5.dp),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {

                    Surface(
                        color = rose,
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Text(
                            text = "Phone: 1 (778) 641-4500 | E-mail: canleather@hotmail.com",
                            color = Color.White,
                            fontSize = 12.sp,
                            modifier = Modifier.padding(4.dp).clickable {
                                uriHandler.openUri("mailto:canleather@hotmail.com")
                            },
                            textAlign = TextAlign.Center
                        )
                    }

                    Column(modifier = Modifier.fillMaxWidth().height(340.dp)
                        .clip(RoundedCornerShape(4.dp))
                        .background(deepRed)
                        .padding(start = 5.dp, end = 5.dp, top = 5.dp)) {

                        // Slideshow Section
                        BoxWithConstraints(modifier = Modifier
                            .fillMaxWidth()
                            .height(300.dp)
                            .clipToBounds()) {
                            val width = maxWidth
                            LazyRow(
                                state = listState,
                                flingBehavior = snapBehavior,
                                modifier = Modifier.fillMaxSize()
                            ) {
                                items(slides.size) { index ->
                                    Box(
                                        modifier = Modifier
                                            .width(width)
                                            .height(300.dp)
                                            .then(
                                                if (isPreview) Modifier.background(deepRed)
                                                else Modifier.paint(
                                                    painter = painterResource(slides[index]),
                                                    contentScale = ContentScale.FillWidth
                                                )
                                            )
                                    )
                                }
                            }
                        }

                        // Page Indicator
                        Row(
                            modifier = Modifier
                                .height(40.dp)
                                .padding(horizontal = 16.dp)
                                .fillMaxWidth(),
                            horizontalArrangement = Arrangement.Center,
                            verticalAlignment = Alignment.CenterVertically
                        ) {
                            repeat(slides.size) { iteration ->
                                val color = if (listState.firstVisibleItemIndex == iteration) Color.White else Color.White.copy(alpha = 0.5f)
                                Box(
                                    modifier = Modifier
                                        .padding(horizontal = 16.dp)
                                        .size(10.dp)
                                        .clip(CircleShape)
                                        .background(color)
                                        .clickable {
                                            scope.launch {
                                                listState.animateScrollToItem(iteration)
                                            }
                                        }
                                )
                            }
                        }
                    }

                    // Contact Info
                    Surface(
                        color = rose,
                        modifier = Modifier.fillMaxWidth()
                    ) {
                        Column(
                            modifier = Modifier.padding(4.dp),
                            horizontalAlignment = Alignment.CenterHorizontally
                        ) {
                            Text(
                                text = "5310 Silver Standard Rd, New Hazelton, V0J 1Y1",
                                color = Color.White,
                                fontSize = 12.sp,
                                textAlign = TextAlign.Center
                            )
                        }
                    }
                }

                Text(
                    text = "British Columbia, Canada",
                    color = deepRed,
                    fontSize = 20.sp,
                    fontWeight = FontWeight.Bold,
                    fontStyle = FontStyle.Italic,
                    modifier = Modifier.padding(4.dp),
                    textAlign = TextAlign.Center
                )
            }

            Spacer(modifier = Modifier.height(16.dp))

            if (isPreview) {
                Box(modifier = Modifier.width(80.dp)
                    .clip(RoundedCornerShape(40.dp)).height(80.dp).background(ashRose))
            } else {
                Image(
                    painter = painterResource(Res.drawable.ic_logo_red),
                    contentDescription = "Logo",
                    modifier = Modifier.width(200.dp).clickable {
                        onBack()
                    },
                )
            }
        }
    }
}


@Preview(device = "id:pixel_tablet")
@Composable
fun TerrencePreview() {
    Terrence {  }
}
